import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { appendTrackingParams } from '../../../utils/tracking';
import { useNavigate } from 'react-router-dom';

const CTASection = () => {
  const navigate = useNavigate();
  const appUrl = import.meta.env.VITE_APP_URL || 'https://app.neevii.com/';
  const handleStartTrial = () => {
    window.location.href = appendTrackingParams(appUrl);
  };

  const handleLearnMore = () => {
    navigate('/subscription');
  };

  const benefits = [
    {
      icon: "Clock",
      text: "Setup in 5 minutes",
      color: "text-blue-400"
    },
    {
      icon: "CreditCard",
      text: "No credit card required",
      color: "text-green-400"
    },
    {
      icon: "Shield",
      text: "Cancel anytime",
      color: "text-purple-400"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 via-background to-secondary/5 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 ai-particles opacity-30"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary/10 rounded-full blur-3xl"></div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="space-y-8">
          {/* Header */}
          <div className="space-y-4">
            <div className="inline-flex items-center space-x-2 bg-card/50 backdrop-blur-sm border border-border rounded-full px-4 py-2">
              <Icon name="Rocket" size={16} className="text-brand-accent" />
              <span className="text-sm text-muted-foreground font-medium">
                Ready to Transform Your Accounting?
              </span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              Start your AI-powered
              <span className="gradient-text block">accounting journey today</span>
            </h2>
            
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Join thousands of entrepreneurs who've already transformed their 
              financial management. No setup fees, no long-term contracts.
            </p>
          </div>

          {/* Benefits */}
          <div className="flex flex-wrap items-center justify-center gap-8">
            {benefits?.map((benefit, index) => (
              <div key={index} className="flex items-center space-x-2">
                <Icon name={benefit?.icon} size={18} className={benefit?.color} />
                <span className="text-sm font-medium text-muted-foreground">
                  {benefit?.text}
                </span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              variant="default"
              size="lg"
              className="btn-primary shadow-brand-interactive px-8"
              onClick={handleStartTrial}
              iconName="Zap"
              iconPosition="left"
            >
              Start Free Trial
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              onClick={handleLearnMore}
              iconName="ArrowRight"
              iconPosition="right"
              className="border-border hover:bg-card/50"
            >
              View Pricing
            </Button>
          </div>

          {/* Trust Signals */}
          <div className="pt-8 border-t border-border/50">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-xl mx-auto">
              <div className="text-center">
                <div className="text-3xl font-bold text-foreground mb-2">12hrs</div>
                <div className="text-primary-foreground/80">Saved Weekly</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-foreground mb-2">95%</div>
                <div className="text-primary-foreground/80">Accuracy Rate</div>
              </div>
            </div>
            <div className="mt-8 text-sm text-muted-foreground">
            <span>Your data is encrypted and secure.</span>
           </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CTASection;